/**
 * Download file from server and open in new tab
 */
export const downloadFile = async (filePath: string) => {
    const response = await fetch(`/uploads/${filePath}`);

    if (!response.ok) {
        throw new Error('File not found');
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    window.open(url, '_blank');
};